import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import asObject from 'utils/objects/asObject.util';

import CN from './AllowanceTable.module.scss';

const AllowanceTable = ({ value, isDarkMode }) => {
  const { t } = useTranslation();
  const { allowance: total, used_days: used, upcoming_days: future, remaining_days: remaining, category_name: categoryName } = asObject(value);

  return (
    <div
      data-bem="AllowanceTable"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div data-bem="AllowanceTable__header" className={CN.header}>
        <div className={CN.title}>
          <span>{categoryName}</span>
        </div>
      </div>

      <div data-bem="AllowanceTable__content" className={CN.body}>
        <div data-bem="AllowanceTable__allowance" className={CN.head}>
          {t('scheduler.timeOff.allowance')}
        </div>
        <div data-bem="AllowanceTable__used" className={CN.head}>
          {t('scheduler.timeOff.used')}
        </div>
        <div data-bem="AllowanceTable__future" className={CN.head}>
          {t('scheduler.timeOff.future')}
        </div>
        <div data-bem="AllowanceTable__remaining" className={CN.head}>
          {t('scheduler.timeOff.remaining')}
        </div>
        <div className={CN.cell}>
          <strong className={CN.green}>
            {' '}
            {total || 0} {t('scheduler.timeOff.days')}
          </strong>
        </div>
        <div className={CN.cell}>
          <strong className={CN.red}>
            {' '}
            {used || 0} {t('scheduler.timeOff.days')}
          </strong>
        </div>
        <div className={CN.cell}>
          <strong className={CN.yellow}>
            {' '}
            {future || 0} {t('scheduler.timeOff.days')}
          </strong>
        </div>
        <div className={CN.cell}>
          <strong className={CN.purple}>
            {' '}
            {remaining || 0} {t('scheduler.timeOff.days')}
          </strong>
        </div>
      </div>
    </div>
  );
};

const AllowanceTableHoc = withTheme()(AllowanceTable);

export default AllowanceTableHoc;
